import { render, staticRenderFns } from "./ModificarOrden.vue?vue&type=template&id=bc9067b8&scoped=true&"
import script from "./ModificarOrden.vue?vue&type=script&lang=js&"
export * from "./ModificarOrden.vue?vue&type=script&lang=js&"
import style0 from "./ModificarOrden.vue?vue&type=style&index=0&id=bc9067b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9067b8",
  null
  
)

export default component.exports